import { defineModule } from '../../engine/module';
import { AboutScreen } from './AboutScreen';

// The platform module's UI: the tenant-level primitives that have API resources but had no
// screens — roles (RBAC), custom field definitions, webhook endpoints, connected apps (OAuth/MCP
// grants) — plus the About page (build identity of the web and the API). They live in Configuration → Organisation.

export const platformModule = defineModule({
  name: 'platform',
  nav: [
    {
      label: 'Organisation',
      area: 'config',
      order: 10,
      items: [
        { label: 'Roles', to: '/roles', icon: 'shield', permission: 'roles:list' },
        { label: 'Custom fields', to: '/custom-fields', icon: 'sliders-horizontal', permission: 'custom-field-defs:list' },
        { label: 'Webhooks', to: '/webhooks', icon: 'plug-zap', permission: 'webhook-endpoints:list' },
        { label: 'Connected apps', to: '/connected-apps', icon: 'plug-zap', permission: 'connected-apps:list' },
        { label: 'About', to: '/about', icon: 'help-circle' },
      ],
    },
  ],
  screens: [
    { path: '/roles', resource: 'roles', kind: 'list', title: 'Roles', subtitle: 'Who can do what. Built-in roles are fixed; add custom roles with their own permission set.', columns: ['name', 'is_builtin'], query: { sort: 'name' }, inspector: true },
    { path: '/roles/:id', resource: 'roles', kind: 'detail', builtinTabs: ['overview', 'activity'] },
    { path: '/custom-fields', resource: 'custom-field-defs', kind: 'list', title: 'Custom fields', subtitle: 'Extra fields per entity type, rendered on every form and detail of that entity.', columns: ['entity_type', 'key', 'label', 'type', 'required', 'order', 'is_active'], filters: [{ field: 'entity_type', kind: 'chips' }], query: { sort: 'entity_type' }, inspector: true },
    { path: '/custom-fields/:id', resource: 'custom-field-defs', kind: 'detail', builtinTabs: ['overview', 'activity'] },
    { path: '/webhooks', resource: 'webhook-endpoints', kind: 'list', title: 'Webhooks', subtitle: 'Signed deliveries of domain events to external URLs.', columns: ['url', 'event_types', 'is_active'], inspector: true },
    { path: '/webhooks/:id', resource: 'webhook-endpoints', kind: 'detail', builtinTabs: ['overview', 'activity'] },
    {
      // Apps (MCP clients) a person authorised to act as them; an owner/admin sees everyone's (RLS).
      path: '/connected-apps',
      resource: 'connected-apps',
      kind: 'list',
      title: 'Connected apps',
      subtitle: 'Apps you allowed to use NovaPSA as you, through MCP. Revoke one and every token it holds stops working at once.',
      columns: ['client_name', 'redirect_host', 'scope', 'consented_by_email', 'created_at', 'last_used_at', 'revoked_at'],
      query: { sort: '-created_at' },
      create: false,
      inspector: true,
    },
    { path: '/connected-apps/:id', resource: 'connected-apps', kind: 'detail', builtinTabs: ['overview'] },
    { path: '/about', resource: '', kind: 'custom', title: 'About', component: AboutScreen },
  ],
  commands: [
    { id: 'connected-apps', label: 'Connected apps', kind: 'go to', icon: 'plug-zap', keywords: 'mcp oauth assistant claude app revoke token access', run: ({ navigate }) => navigate('/connected-apps') },
  ],
});
